import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { PendingActivity } from "./PendingActivities";
import CreatorInfo from "./CreatorInfo";
import { formatLeft } from "./PendingActivities";
import "./PendingActivities.scss";

interface ActivityItemProps {
  activity: PendingActivity;
  showCreatorInfo?: boolean;
  type: "booking" | "application" | "invitation";
  renderActions?: () => React.ReactNode;
  renderDateTime?: () => React.ReactNode;
  renderCompensation?: () => React.ReactNode;
}

const itemVariants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

const ActivityItem: React.FC<ActivityItemProps> = ({
  activity,
  showCreatorInfo,
  type,
  renderActions,
  renderDateTime,
  renderCompensation,
}) => {
  return (
    <motion.div className="booking-row" variants={itemVariants}>
      <div className="booking-left">
        {showCreatorInfo ? (
          <CreatorInfo
            avatarUrl={activity.avatarUrl}
            name={activity.name}
            username={activity.username}
            instagramFollowersCount={activity.instagramFollowersCount}
            tiktokFollowersCount={activity.tiktokFollowersCount}
          />
        ) : (
          <div className="booking-icon-box">
            <FontAwesomeIcon icon={faEnvelope} className="booking-icon" />
          </div>
        )}

        <div className="booking-info">
          <div className="booking-title">{activity?.venue?.name}</div>
          <div className="booking-address">
            {activity?.venue?.addressDisplay}
          </div>
          {renderCompensation ? (
            renderCompensation()
          ) : type === "booking" && activity.securityCode ? (
            <div className="booking-comp">
              Voucher: {activity.securityCode} - ${activity?.foodCompAmount}
              {" credit "}
              {activity?.guestAllowed && " ∘ 1 guest"}
            </div>
          ) : null}
        </div>
      </div>

      <div className="booking-right">
        {renderDateTime ? (
          renderDateTime()
        ) : (
          <div className="booking-datetime">
            <div className="booking-date">
              {activity.applicationDate
                ? dayjs
                    .utc(activity.applicationDate?.date)
                    .format("MMMM D, YYYY")
                : formatLeft((activity as any).details)}
            </div>
            <div className="booking-time">
              {activity.applicationDate?.hour || "-"}
            </div>
          </div>
        )}

        {renderActions && (
          <div className="booking-actions">{renderActions()}</div>
        )}
      </div>
    </motion.div>
  );
};

export default ActivityItem;

